// import actions
import trabajadorAction from './actions/trabajador'

// import getters

// import mutations

// import states

const actions = { ...trabajadorAction }

const getters = { }

const mutations = { }

const state = { }

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
}
